export const AUTH_SKIP_PATHS = ['/auth/login', '/auth/logout', '/auth/password'];
/** In-memory only — never sent as an HTTP header. */
export const SKIP_AUTH_RETRY = Symbol('skipAuthRetry');
/**
 * The generated client throws the parsed error body, which carries no status, so
 * callers cannot tell an expected 404 from a broken server. The body already uses
 * `status` for its own fail/error marker, hence the longer name.
 */
export const HTTP_STATUS_CODE_KEY = 'httpStatusCode';
